<template>
  <m-dialog
    ref="dialog"
    :title="isReadInfo ? 'Detail Kuesioner' : id ? 'Edit Kuesioner' : 'Buat Kuesioner'"
    :btnsave="!isReadInfo"
    labelSave="Simpan"
    bg-color="#f6f5f5"
    @save="pendingSave"
  >
    <template v-slot:extra>
      <div class="d-flex" style="max-height: 100px">
        <v-tabs v-model="menu" align-tabs="center" background-color="#EDEEF1" height="70">
          <v-tab v-for="tab in tabList" :key="tab.value" :value="Number(tab.value)">
            <v-icon left>{{ tab.icon }}</v-icon> <span class="text-capitalize"> {{ tab.text }} </span>
          </v-tab>
        </v-tabs>
      </div>
    </template>
    <v-container class="mt-5">
      <v-row row wrap justify="center" align="center">
        <v-col cols="12" md="9" sm="12">
          <div v-show="menu === 0">
            <Information
              ref="information"
              :info="info"
              :users="users"
              :groups="groups"
              :is-tenant="isTenantScope"
              :isReadonly="isReadonly"
              :isReadInfo="isReadInfo"
              @info="setInfo"
            ></Information>
          </div>
          <div v-show="menu === 1">
            <Survey
              ref="survey"
              :surveys="surveys"
              :isReadonly="isReadonly"
              :isReadInfo="isReadInfo"
              :info="info"
              @surveys="setSurvey"
              @allNoResponse="setAllNoResponse"
            ></Survey>
          </div>
          <div v-show="menu === 2">
            <Preview ref="preview" :surveys="surveys" :isReadInfo="isReadInfo" :info="info"></Preview>
          </div>
        </v-col>
      </v-row>
    </v-container>
    <DlgSave ref="formSave" :is-pengumuman="isPengumuman" @save="onSave" />
  </m-dialog>
</template>
<script>
import Information from '@/modules/kuesioner/components/Information.vue'
import Survey from '@/modules/kuesioner/components/Survey.vue'
import Preview from '@/modules/kuesioner/components/Preview.vue'
import DlgSave from '@/modules/kuesioner/components/ConfirmSave.vue'
export default {
  props: {
    users: {
      type: Array,
      default: () => [],
    },
    groups: {
      type: Array,
      default: () => [],
    },
    isTenant: {
      type: Boolean,
      default: false,
    },
  },
  components: { Information, Survey, Preview, DlgSave },
  data() {
    return {
      menu: 0,
      info: {},
      surveys: [],
      isReadonly: false,
      isReadInfo: false,
      isAllNoResponse: false,
      id: null,
    }
  },
  computed: {
    isPengumuman() {
      return Number(this.getDeepObj(this.info, 'k_kategori_kuesioner')) === 2
    },
    isTenantScope() {
      return this.isTenant || (this.$route.name || '').indexOf('tenant-') === 0
    },
    scopeId() {
      return this.isTenantScope ? this.tenant_id : this.organisasi_id
    },
    scopePayload() {
      return {
        organisasi_id: this.scopeId,
        is_tenant: this.isTenantScope,
      }
    },
    tabList() {
      const isPengumuman = this.isPengumuman
      return [
        {
          icon: 'mdi-information-outline',
          text: 'Informasi Umum',
          value: 'Information',
        },
        {
          icon: 'mdi-monitor-edit',
          text: isPengumuman ? 'Konten Masook' : 'Kuesioner Masook',
          value: 'Survey',
        },
        {
          icon: 'mdi-eye',
          text: isPengumuman ? 'Pratinjau' : 'Pratinjau Kuesioner',
          value: 'Preview',
        },
      ]
    },
    tab() {
      return this.tabList[this.menu || 0]
    },
  },
  methods: {
    open(obj, isReadonly = false) {
      this.reset()
      this.$refs.dialog.open()

      this.$nextTick(() => {
        this.$refs.information.reset()
        this.$refs.survey.reset()

        if ((obj && obj.kuesioner && Number(obj.kuesioner.jumlah) > 0) || isReadonly) {
          this.isReadonly = true
        }

        if (isReadonly) {
          this.isReadInfo = true
        }

        if (obj && obj.kuesioner) {
          this.initForm(obj.kuesioner)
        }
      })
    },
    setInfo(item) {
      this.info = Object.assign({}, item)
    },
    setSurvey(item) {
      this.surveys = JSON.parse(JSON.stringify(item || []))
    },
    setAllNoResponse(val) {
      this.isAllNoResponse = val
    },
    reset() {
      this.id = null
      this.surveys = []
      this.info = {}
      this.menu = 0
      this.isReadonly = false
      this.isReadInfo = false
      this.isAllNoResponse = false
    },
    initForm(obj) {
      this.id = this.getDeepObj(obj, 'kuesioner_id')
      const name = [
        'nama',
        'deskripsi',
        'k_kategori_kuesioner',
        'is_wizard',
        'k_tipe_pengisian',
        'is_responden',
        'wkt_mulai',
        'wkt_selesai',
        'hari_mulai',
        'hari_selesai',
        'jam_mulai',
        'jam_selesai',
        'mode_kuesioner',
        'is_sebelum_presensi',
        'is_required',
      ]
      let info = {}

      name.forEach((key) => {
        this.$set(info, key, obj[key])
      })

      let responden = this.getDeepObj(obj, 'user_ids') || []
      let soals = (obj && obj.kuesioner_soals) || []
      let items = []
      soals.forEach((item) => {
        items.push({
          kuesioner_soal_id: item.kuesioner_soal_id,
          label: item.label,
          k_tipe_soal: item.k_tipe_soal,
          is_required: item.is_required,
          opsi: item.kuesioner_opsis || [],
        })
      })

      this.$refs.survey.initForm(items)
      this.$refs.information.initForm(info, responden)

      this.$nextTick(() => {
        this.$refs.information.changeUser(obj.is_responden)
      })
    },
    async pendingSave() {
      const info = await this.$refs.information.getValue()
      const quiz = (await this.$refs.survey.getValue(this.isReadonly)) || []
      if (!Object.keys(info).length) {
        this.menu = 0
        return
      }
      if (quiz.length === 0 && !this.isReadonly) {
        this.menu = 1
        return
      }
      // Jika semua pertanyaan bertipe "Tidak Membutuhkan Jawaban" dan bukan pengumuman, langsung simpan sebagai draft
      if (this.isAllNoResponse && !this.isPengumuman) {
        this.onSave(1)
        return
      }
      this.$refs.formSave.open()
    },
    async onSave(tipe) {
      const info = await this.$refs.information.getValue()
      const quiz = (await this.$refs.survey.getValue(this.isReadonly)) || []

      this.$store
        .dispatch('kuesioner/update', Object.assign({}, this.scopePayload, {
          obj: {
            id: this.id,
            params: Object.assign({}, info, { soals: quiz, k_status_kuesioner: tipe }),
          },
        }))
        .then(() => {
          this.$refs.dialog.resolve()
          this.$success(this.isPengumuman ? 'Pengumuman berhasil diperbarui' : 'Kuesioner berhasil diperbarui')
          this.$emit('reload')
        })
    },
  },
}
</script>
<style scoped>
.bg-kuesioner {
  background: #edeef1 0% 0% no-repeat padding-box;
  opacity: 1;
}
</style>
